import { eachDayOfInterval, format, isAfter, isBefore, isSameDay } from 'date-fns';
import { uuidRegEx } from '@utils/consts';
import { AddTaskScheduleDays } from './types';

export const toDayKey = (date: Date) => format(date, 'yyyy-MM-dd');

export const getRangeDays = ({ from, to }: AddTaskScheduleDays) =>
  from && to ? eachDayOfInterval({ start: from, end: to }) : [];

export const getSelectedDays = (days: AddTaskScheduleDays) =>
  getRangeDays(days).filter((day) => !days.excluded.includes(toDayKey(day)));

export const getExcludedDays = (days: AddTaskScheduleDays) =>
  getRangeDays(days).filter((day) => days.excluded.includes(toDayKey(day)));

export const toggleDay = (days: AddTaskScheduleDays, day: Date): AddTaskScheduleDays => {
  const { from, to, excluded } = days;

  if (!from || !to) return { from: day, to: day, excluded: [] };
  if (isSameDay(from, to) && isSameDay(day, from)) return { from: null, to: null, excluded: [] };
  if (isBefore(day, from)) return { ...days, from: day };
  if (isAfter(day, to)) return { ...days, to: day };

  const key = toDayKey(day);
  return {
    ...days,
    excluded: excluded.includes(key) ? excluded.filter((el) => el !== key) : [...excluded, key],
  };
};

export const isExistingTask = (id: string) => uuidRegEx.test(id);
